import {
  TICKET_LIST_REQUEST,
  TICKET_LIST_SUCCESS,
  TICKET_LIST_FAILURE,
  TICKET_DETAIL_REQUEST,
  TICKET_DETAIL_SUCCESS,
  TICKET_DETAIL_FAILURE,
  TICKET_ACTION_REQUEST,
  TICKET_ACTION_SUCCESS,
  TICKET_ACTION_FAILURE,
  TICKET_CREATE_REQUEST,
  TICKET_CREATE_SUCCESS,
  TICKET_CREATE_FAILURE,
  UPDATE_TICKET_FILTERS
} from '../../actions/ticketingActions'

/**
 * Casos e incidentes (URBWEB-4372).
 *
 * Tres cosas en vuelo, cada una con su estado: el listado (`isFetching`), el
 * caso abierto (`detailLoading`) y lo que se guarda desde el detalle
 * (`isSaving`). Separarlas es lo que deja a la pantalla decir qué está
 * pasando: antes, guardar un comentario dejaba el detalle en blanco.
 *
 * `needRefresh` lo levanta cualquier guardado; el listado lo baja al empezar
 * a pedir, como en el resto del panel.
 */
export const initialState = {
  data: [],
  count: 0,
  isFetching: false,
  error: null,
  filters: {
    ticket_type: '',
    status: '',
    priority: '',
    search: '',
    page: 1
  },
  currentTicket: null,
  detailLoading: false,
  detailError: null,
  isSaving: false,
  saveError: null,
  needRefresh: false,
  /** Cuántos casos se han creado: la pantalla lo mira para avisar y cerrar. */
  creados: 0,
  /** Cuántas acciones han salido bien sobre el caso abierto, por lo mismo. */
  acciones: 0,
  /** Cuántos casos trae una página, para saber cuántas hay. */
  porPagina: 0
}

/** Lo que trae una respuesta de listado, venga paginada o en crudo. */
const listaDe = datos => {
  if (Array.isArray(datos)) return { results: datos, count: datos.length }
  const results = (datos && datos.results) || []
  const count =
    datos && datos.count !== undefined ? datos.count : results.length
  return { results, count }
}

const errorDe = action => action.errors || action.data || {}

export default function ticketingReducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_TICKET_FILTERS:
      return {
        ...state,
        filters: { ...state.filters, ...action.payload },
        needRefresh: true
      }

    case TICKET_LIST_REQUEST:
      return { ...state, isFetching: true, error: null, needRefresh: false }

    case TICKET_LIST_SUCCESS: {
      const { results, count } = listaDe(action.data)
      return {
        ...state,
        isFetching: false,
        data: results,
        count,
        // La API no dice su tamaño de página: se aprende de la más llena que
        // se haya visto, que es el tamaño salvo en la última.
        porPagina: Math.max(state.porPagina, results.length)
      }
    }

    case TICKET_LIST_FAILURE:
      // Sin datos: dejar los de antes con un error al lado haría creer que
      // los filtros nuevos dieron ese resultado.
      return {
        ...state,
        isFetching: false,
        data: [],
        count: 0,
        error: errorDe(action)
      }

    case TICKET_DETAIL_REQUEST:
      // El caso abierto se queda: al volver de guardar, la pantalla no
      // parpadea ni pierde lo que el operador estaba escribiendo.
      return { ...state, detailLoading: true, detailError: null }

    case TICKET_DETAIL_SUCCESS:
      return {
        ...state,
        detailLoading: false,
        currentTicket: action.data || null
      }

    case TICKET_DETAIL_FAILURE:
      return {
        ...state,
        detailLoading: false,
        currentTicket: null,
        detailError: errorDe(action)
      }

    case TICKET_CREATE_REQUEST:
    case TICKET_ACTION_REQUEST:
      return { ...state, isSaving: true, saveError: null }

    case TICKET_CREATE_SUCCESS:
      return {
        ...state,
        isSaving: false,
        needRefresh: true,
        creados: state.creados + 1
      }

    case TICKET_ACTION_SUCCESS:
      return {
        ...state,
        isSaving: false,
        needRefresh: true,
        acciones: state.acciones + 1,
        currentTicket: action.data
          ? { ...state.currentTicket, ...action.data }
          : state.currentTicket
      }

    case TICKET_CREATE_FAILURE:
    case TICKET_ACTION_FAILURE:
      return { ...state, isSaving: false, saveError: errorDe(action) }

    default:
      return state
  }
}
